import request from "../../utils/request";

export const state = {};

export const actions = {
  getPolicyConfigDetail({ dispatch, commit }, params) {
    return request({
      url: appUrl + "/api/company/policy/config-detail",
      params,
      callBack: (type, value) => {
        return value?.data?.data || null;
      },
    });
  },
  getPolicyCancellation({ dispatch, commit }, params) {
    return request({
      url: appUrl + "/api/company/policy/cancellation",
      params,
      callBack: (type, value) => {
        return value?.data?.data || null;
      },
    });
  },
};
